<template>
  <div class="modal-backdrop">
    <div class="card deletecard bordernone borderadius12 col-lg-4 col-md-8 mt-md-4 col-11 p-0" v-if="!displayAPIerrorModal">
      <div class="modal-content borderadius12 p-2">
        <div class="modal-header delete-modal">
            <h5 class="modal-title fontsize20 black80 proximanova" id="deleteExpModalLabel">Are you sure you want to delete this record ?</h5>
            <button type="button" class="close" @click="closeDeleteJobModal('NOT SUCCESS')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body modal-delete text-center">
            <span class="btn border button-cancel11 borderradius20 mr-2 pr-4 pl-4 navtoPage proximanova" @click="closeDeleteJobModal('NOT SUCCESS')">No</span>
            <span class="btn sign-up-button blackbackhroundsignin borderradius20 fontsizemd pr-4 pl-4 pointer proximanova" @click="deleteJob">Yes</span>
         </div>
      </div>
  </div>
  <div class="card maincard bordernone col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12" v-else>
      <div class="modal-content postmodalcontent borderadius12">
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <span class="proximanova-bold fontsize18 black">Error</span>
            <span class="mt-2 proximanova fontsize16 black60">Oops, Something went wrong.</span>
            <span class="mt-1 proximanova fontsize16 black60">Please try again later.</span>
            <button class="backgroundcolor3 white bordernone mouseoverbtn2 proximanova mt-4 p-1 borderradius20" @click="closeDeleteJobModal('NOT SUCCESS')" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpjob from "@/js/http-postjob.js"
export default {
    props : [
        'deleteJobObject'
    ],
    data() {
        return{
          displayAPIerrorModal : false,
        }
    },
    mounted() {
        console.log(this.deleteJobObject)
    },
    methods: {
        closeDeleteJobModal : function(status) {
          this.$emit('closeDeleteJobModal', status);
        },
        deleteJob(){
        console.log(this.deleteJobObject.jobId)
        var vm = this;
        httpjob.put('/postjob/updateJobStatusById?jobId='+this.deleteJobObject.jobId+'&jobStatus=DELETE')
        .then((response) => {
          console.log(response)
          vm.$toast.success("Deleted SUccessfully")
          this.closeDeleteJobModal('SUCCESS')
        }).catch((e) => {
          console.log(e)
          // vm.$toast.error(e.data.errorMessage)
          this.displayAPIerrorModal = true;
          setTimeout(() => {
            vm.closeDeleteJobModal('NOT SUCCESS')  
          }, 5000);
        })
      },
    },
    beforeDestroy() {
        
    }
}
</script>

<style scoped>
.modal-backdrop {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000 !important;
}
.modal-delete {
  background-color: white;
  border-radius: .3rem;
  padding-top: 0 !important;
}
.delete-modal{
  border: none;
}
button:active {
    outline: none;
    border: none;
}
.btn:focus{
  box-shadow: none;
}
.card{
    margin: 0 auto;
}
.close{
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.deletecard{
    margin-top: 15% !important;
}
</style>